import React, { useEffect } from "react";
import { Loader } from "@culturehq/components";

type GetVideoThumbnailProps = {
  video: string;
  onEdit?: (thumb: Blob) => void;
  onProcessing?: (value: boolean) => void;
  asButtonView?: boolean;
};

const GetVideoThumbnail: React.FC<GetVideoThumbnailProps> = ({
  video, onEdit, onProcessing, asButtonView
}) => {
  useEffect(() => {
    const getThumb = async () => {
      const videoElement = document.createElement("video");
      videoElement.src = video;
      videoElement.currentTime = 1;

      return new Promise<Blob>((resolve, reject) => {
        videoElement.addEventListener("loadeddata", () => {
          const canvas = document.createElement("canvas");
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          const context = canvas.getContext("2d");

          if (context) {
            context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(blob => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error("Failed to create blob from canvas"));
              }
            }, "image/png");
          } else {
            reject(new Error("Failed to get canvas context"));
          }
        });

        videoElement.addEventListener("error", () => {
          reject(new Error("Error loading video"));
        });
      });
    };

    const handleSave = async () => {
      if (onEdit) {
        if (onProcessing) onProcessing(true);
        const result = await getThumb();
        if (onProcessing) onProcessing(false);
        onEdit(result);
      }
    };

    if (video) handleSave();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (asButtonView) {
    return <></>;
  }

  return <Loader loading />;
};

export default GetVideoThumbnail;
